import { Descriptions, Divider } from "antd";
 import { Typography } from "antd";
 import { labelStyle } from "../RequestUtil";

 const { Title } = Typography;

 const CivilPlaintiffRequest = ({ serviceData, requestData }) => {
   const reactiveColumn = {
     xxl: 1,
     xl: 1,
     lg: 1,
     md: 1,
     sm: 1,
     xs: 1,
   };
   return (
     <>
       <Title level={4} style={{ color: "#001529", marginBottom: 0 }}>
       민사소송 피고
       </Title>
       <Divider style={{ marginTop: 10 }} />
       <div
         style={{
           backgroundColor: "white",
           padding: 15,
           paddingTop: 5,
           marginBottom: 20,
           borderRadius: 5,
         }}
       >
         <Descriptions
           title="민사소송 피고 관련 정보"
           bordered
           column={reactiveColumn}
           size={"small"}
           style={{ marginTop: 20, marginBottom: 15 }}
         >

           <Descriptions.Item
             label="사건의 종류"
             labelStyle={labelStyle}
           >
             {serviceData.civilPlaintiff.caseType.join(", ")}
           </Descriptions.Item>

           {serviceData.civilPlaintiff.caseType.includes("기타") ? (
             <Descriptions.Item label="기타 이유" labelStyle={labelStyle}>
               {serviceData.civilPlaintiff.etc}
             </Descriptions.Item>
           ) : null}

           <Descriptions.Item label="원고가 청구하는 채권액" labelStyle={labelStyle}>
             {serviceData.civilPlaintiff.dept.amount.toLocaleString()}
           </Descriptions.Item>

           <Descriptions.Item label="상대방의 청구에 대한 채권 인정 여부" labelStyle={labelStyle}>
             {serviceData.civilPlaintiff.dept.recognized}
           </Descriptions.Item>
         </Descriptions>

         <Descriptions
           title="상세 내용 및 연락처"
           bordered
           column={reactiveColumn}
           size={"small"}
           style={{ marginTop: 20, marginBottom: 15 }}
         >           
           <Descriptions.Item label="상세 내용" labelStyle={labelStyle}>
             {serviceData.description
               ? serviceData.description.split("\n").map((line, idx) => {
                   return (
                     <span key={idx}>
                       {line}
                       <br />
                     </span>
                   );
                 })
               : ""}
           </Descriptions.Item>
           <Descriptions.Item label="연락처" labelStyle={labelStyle}>
             {serviceData.contact}
           </Descriptions.Item>
           <Descriptions.Item label="프로모션" labelStyle={labelStyle}>
             {serviceData.promotionCode}
           </Descriptions.Item>
         </Descriptions>
       </div>
     </>
   );
 };

 export default CivilPlaintiffRequest;